import { all, cancel, fork, put, race, take } from "redux-saga/effects";

import { requestCategories } from "../../actions/categories";
import { requestFeatured } from "../../actions/featured";
import { SET_AUCTION } from "../../actions/controllers/auction";
import { SET_LOCALE } from "../../actions/controllers/locale";

export function* loopUnderAuction(auction, locale) {
  // Start loop
  const task = yield fork(loop, auction, locale);

  // Stop conditions
  yield race({
    setAuction: take(SET_AUCTION),
    setLocale: take(SET_LOCALE)
  });

  // End loop
  yield cancel(task);
}

function* loop(auction, locale) {
  try {
    yield all([
      put(requestCategories(auction, locale)),
      put(requestFeatured(auction, locale))
    ]);
  } finally {
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/loopUnderAuction.js